const handleImageModal = () => {
	$('.js-modal-image').magnificPopup({
		type: 'image',
		closeOnContentClick: true,
		mainClass: 'mfp-img-mobile',
		image: {
			verticalFit: true
		}
	});
}

handleImageModal();
